import { PlusOutlined } from '@ant-design/icons'
import type { InputRef } from 'antd'
import { Input, Tag } from 'antd'
import { t } from 'i18next'
import { OTHER } from 'pages/exam/constants'
import { TweenOneGroup } from 'rc-tween-one'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const StyledTag = styled(Tag)<{ $disabled?: boolean }>`
  background: var(--color-primary-108);
  color: white;
  ${({ $disabled }) => ($disabled ? 'cursor: not-allowed;' : '')}
`
const StyledTagChild = styled(Tag)`
  border-radius: 20px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  height: 24px;
  align-items: center;
  svg {
    border-radius: 50%;
    color: var(--color-red-107);
    background-color: var(--color-red-104);
    padding: 2px;
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
`

interface IProps {
  label?: string
  value?: Array<string>
  disabled?: boolean
  onChange?: (value: Array<string>) => void
  showAddOther?: boolean
}

const AddTag = (props: IProps) => {
  const { label, value, onChange, disabled, showAddOther = true } = props
  const [tags, setTags] = useState<Array<string>>(value || [])
  const [inputVisible, setInputVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<InputRef>(null)
  const hasExitOther = tags?.includes(OTHER)

  useEffect(() => {
    setTags(value || [])
  }, [value])

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus()
    }
  }, [inputVisible])

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag)
    setTags(newTags)
    if (onChange) onChange(newTags)
  }

  const showInput = () => {
    setInputVisible(!disabled)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue])
      if (onChange) onChange([...tags, inputValue])
    }
    setInputVisible(false)
    setInputValue('')
  }

  const forMap = (tag: string) => {
    const tagElem = (
      <StyledTagChild
        closable={!disabled}
        color="geekblue"
        onClose={(e) => {
          e.preventDefault()
          handleClose(tag)
        }}>
        <span>{tag === OTHER ? t(OTHER) : tag}</span>
      </StyledTagChild>
    )
    return (
      <span key={tag} style={{ display: 'inline-block' }}>
        {tagElem}
      </span>
    )
  }

  const tagChild = tags.map(forMap)

  const handleAddOther = () => {
    if (onChange) onChange([...tags, OTHER])
    setTags([...tags, OTHER])
  }
  return (
    <>
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={{ width: 200 }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      ) : (
        <>
          {!disabled && (
            <>
              <StyledTag $disabled={disabled} onClick={showInput}>
                <PlusOutlined /> {t(label || 'add')}
              </StyledTag>
              {showAddOther && !hasExitOther && (
                <StyledTag $disabled={disabled} onClick={handleAddOther}>
                  <PlusOutlined /> {t('other')}
                </StyledTag>
              )}
            </>
          )}
        </>
      )}
      <div style={{ marginTop: 16 }}>
        <TweenOneGroup
          enter={{
            scale: 0.8,
            opacity: 0,
            type: 'from',
            duration: 100
          }}
          onEnd={(e) => {
            if (e.type === 'appear' || e.type === 'enter') {
              ;(e.target as any).style = 'display: inline-block'
            }
          }}
          leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
          appear={false}>
          {tagChild}
        </TweenOneGroup>
      </div>
    </>
  )
}

export default AddTag
